(function($){
    
	/* Document Ready */
	$(document).ready(function() {
        
        /* YouTube Video Embed */
        var $video_icon = $('.video_icon');
        if ($video_icon.length) {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            $video_icon.on("click", function() {
                var $this = $(this),
                    $youtube_id = $(this).data('youtubeid'),
                    $video_id = $(this).data('videoid'),
                    $parent = $(this).parents('.video_parent');
                $this.fadeOut(300);
                $this.parent('.video--content').fadeOut(300);
                player = new YT.Player($video_id, {
                    videoId: $youtube_id,
                    height: $parent.outerHeight(),
                    width: $parent.outerWidth(),
                    playerVars: {rel: 0},
                    events: {
                        'onReady' : onPlayerReady
                    }
                });

            });
        }

        function onPlayerReady(event) {
            event.target.playVideo();
        }
        
        $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
	});

})(jQuery);